export default __webpack_public_path__ + "static/media/slider4.4600eafe.jpg";